export type BusinessNeedsOption = { label: string; value: string };

export const STORAGE_UNIT_OPTIONS: BusinessNeedsOption[] = [
  { label: 'Pallets', value: 'Pallets' },
  { label: 'Square feet', value: 'SquareFeet' },
];

export const GOODS_PALLETISED_OPTIONS: BusinessNeedsOption[] = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

export const OUTBOUND_UNIT_OPTIONS: BusinessNeedsOption[] = [
  { label: 'Pallets', value: 'Pallets' },
  { label: 'Cartons', value: 'Cartons' },
];

export const selectedOption = (
  options: BusinessNeedsOption[],
  value?: string | null
) => options.find((option) => option.value === value) ?? null;

export const goodsPalletisedAnswerFrom = (
  goodsPalletised: boolean | null | undefined
) => {
  if (goodsPalletised == null) return '';
  return goodsPalletised ? 'Yes' : 'No';
};

export type PalletisedGoodsFormValues = {
  goodsPalletised?: string;
  palletWidthInMetres?: number | null;
  palletLengthInMetres?: number | null;
  palletHeightInMetres?: number | null;
  palletWeightInKg?: number | null;
};

export const palletisedGoodsPayload = (values: PalletisedGoodsFormValues) => {
  const isPalletised = !values.goodsPalletised
    ? null
    : values.goodsPalletised === 'Yes';
  return {
    goodsPalletised: isPalletised,
    palletWidthInMetres: isPalletised
      ? values.palletWidthInMetres ?? null
      : null,
    palletLengthInMetres: isPalletised
      ? values.palletLengthInMetres ?? null
      : null,
    palletHeightInMetres: isPalletised
      ? values.palletHeightInMetres ?? null
      : null,
    palletWeightInKg: isPalletised ? values.palletWeightInKg ?? null : null,
  };
};
